<template>
  <div :class="`app-wrapper ${pageKey == 'index' ? 'garyBody' : ''}`">
    <mHeader />
    <router-view v-if="pageKey == 'index' || pageKey == 'searchPage'" :key="key" class="" />
    <div v-else-if="pageType == 'list'" style="padding-bottom: 50px">
      <div v-if="isDesktop()" class="wrap">
        <breadcrumb class="breadcrumb-container" />
        <div style="background: #fff; margin-top: -4px" class="pt30 pr30">
          <div class="con-t fr">
            <input v-model="searchStr2" @keyup.enter="searchFunc" type="text" class="con-t-input" placeholder="请输入搜索内容" />
            <div @click="searchFunc" class="con-t-searchbtn">
              <i class="el-icon-search"></i>
            </div>
          </div>
          <div class="clear"></div>
          <div class="dflex mt20">
            <leftNav :pageType="pageType" style="paddint-top: 0"></leftNav>
            <router-view ref="listRef" :key="key" :pageKey="pageKey" class="flex-sub" style="width: 0" />
          </div>
        </div>
      </div>
      <div v-else>
        <breadcrumb class="breadcrumb-container" />
        <div class="ml10 mr10" style="background: #fff; margin-top: -4px; padding: 10px">
          <div class="con-t fr">
            <input v-model="searchStr2" @keyup.enter="searchFunc" type="text" class="con-t-input" placeholder="请输入搜索内容" />
            <div @click="searchFunc" class="con-t-searchbtn">
              <i class="el-icon-search"></i>
            </div>
          </div>
          <div class="clear"></div>

          <div class="dflex mt10">
            <router-view ref="listRef" :key="key" :pageKey="pageKey" class="flex-sub" style="width: 0" />
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="pageType == 'info'" style="padding-bottom: 50px">
      <div v-if="isDesktop()" class="wrap">
        <breadcrumb class="breadcrumb-container" />
        <div style="margin-top: -4px" class="">
          <div class="dflex">
            <leftNav class="mr30" :pageType="pageType"></leftNav>
            <router-view :key="key" :pageKey="pageKey" class="flex-sub" style="width: 0" />
          </div>
          <!-- <div v-else class="dflex">
          <router-view :key="key" :pageKey="pageKey" class="flex-sub ml10 mr10" style="width: 0" />
        </div> -->
        </div>
      </div>
      <div v-else>
        <breadcrumb class="breadcrumb-container" />
        <div class="dflex" style="margin-top: -4px">
          <router-view :key="key" :pageKey="pageKey" class="flex-sub ml10 mr10" style="width: 0" />
        </div>
      </div>
    </div>

    <mFooter />
  </div>
</template>

<script>
import { mixinDevice } from '@/util/mixin'
import mHeader from '@/components/mHeader'
import mFooter from '@/components/mFooter'
import leftNav from './leftNav'
import Breadcrumb from '@/components/Breadcrumb'
export default {
  mixins: [mixinDevice],
  name: 'Layout',
  components: {
    mHeader,
    mFooter,
    leftNav,
    Breadcrumb,
  },
  data() {
    return {
      pageType: '', // 页面类型 list info
      pageKey: '', // 页面关键字 video
      leftNavPath: [
        // 'associationProfile',
        // 'associationDynamic',
        // 'partyActivity',
        // 'goodFaithArbitration',
        // 'trainingInvestigation',
        // 'memberDynamics',
        // 'governmentCommunity',
        // 'encyclopediaOverview',
        // 'bidWinning',
      ],

      // 搜索
      searchStr2: '',

      // 左侧子导航
      leftNavList: [],
    }
  },
  created() {},
  mounted() {},
  computed: {
    key() {
      return this.$route.fullPath
    },
  },
  watch: {
    '$route.path': {
      handler(val) {
        // 清空数据
        this.searchStr2 = ''

        // 页面类型
        this.pageType = ''
        this.pageKey = ''
        if (val.indexOf('/list') >= 0) {
          this.pageType = 'list'
        } else {
          this.pageType = 'info'
        }
        if (val.indexOf('/video/') >= 0) {
          this.pageKey = 'video'
        } else if (val.indexOf('/index') >= 0) {
          this.pageKey = 'index'
        } else if (val.indexOf('/searchPage') >= 0) {
          this.pageKey = 'searchPage'
        }

        console.log('this.pageKey', this.pageKey)
      },
      immediate: true,
    },
  },
  methods: {
    searchFunc() {
      this.$refs['listRef'].searchFunc(this.searchStr2)
      console.log('搜索')
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.app-wrapper {
  position: relative;
  height: 100%;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue